"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftActionsFields = exports.GiftActions = exports.MessageFields = void 0;
var MessageFields;
exports.MessageFields = MessageFields;

(function (MessageFields) {
  MessageFields["Message"] = "message";
})(MessageFields || (exports.MessageFields = MessageFields = {}));

var GiftActions;
exports.GiftActions = GiftActions;

(function (GiftActions) {
  GiftActions[GiftActions["AllAllowed"] = 1] = "AllAllowed";
  GiftActions[GiftActions["AcceptOrExchange"] = 2] = "AcceptOrExchange";
  GiftActions[GiftActions["AcceptOrDonate"] = 3] = "AcceptOrDonate";
  GiftActions[GiftActions["OnlyAccept"] = 4] = "OnlyAccept";
})(GiftActions || (exports.GiftActions = GiftActions = {}));

var GiftActionsFields;
exports.GiftActionsFields = GiftActionsFields;

(function (GiftActionsFields) {
  GiftActionsFields["Actions"] = "giftActions";
  GiftActionsFields["RecipientActions"] = "recipientActions";
  GiftActionsFields["GifterQuestion"] = "gifter_question";
  GiftActionsFields["GifterAffidavit"] = "gifter_affidavit";
})(GiftActionsFields || (exports.GiftActionsFields = GiftActionsFields = {}));